export const isUrl = (url: string): boolean => {
  const pattern = new RegExp(
    /^(http(s)?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._]{2,256}\.[a-z]{2,16}\b([-a-zA-Z0-9@:%_!*'();$,\\;[\]+.~#?&/=]*)$/g,
    'i',
  )
  return !!pattern.test(url)
}
